<template src="./template.html"/>
<style scoped src="./stylesheet.scss" lang="scss"/>

<script>
    export default {
        name: "Footer",
        methods: {
            goAbout() {
                this.$router.push('/about');
            },
            goComune() {
                window.open('http://comune.desenzano.brescia.it', '_blank');
            },
            goLombardia() {
                window.open('https://www.regione.lombardia.it', '_blank');
            }
        }
    }
</script>
